import { secureApi } from './secureApi';

/**
 * Guests API — JWT endpoints via the shared secureApi instance.
 * (tasks/owner-screens-mobile.md step 2; replaces the page's raw axios call.)
 */
export const guestApi = {
  /**
   * One page of the guests list, filtered on the server.
   * @param {Object} params - search, source, minBookings, sortBy, sortOrder, ownerId, page, limit
   * @returns {Promise<Object>} { guests, pagination: { total, page, pages, limit }, stats }
   */
  getPage: async (params = {}) => {
    const response = await secureApi.get('/api/guests', { params });
    return response.data;
  }
};

export default guestApi;
